export const hasUserConsentedToCookies = () => {
  if (typeof document === `undefined`) {
    return false;
  }
  return document.cookie.includes(`OptanonAlertBoxClosed`);
};
